var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_vm._v(_vm._s(_vm.langText))]),_c('v-text-field',{attrs:{"outline":"","single-line":"","value":_vm.embedHtml,"onclick":"this.select()"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }